import React from 'react';
import AppRouter from "./Router";

import './CSS/styles.css';

function App(): JSX.Element {
  return <div className="container">
    <AppRouter />
  </div>;
}

export default App;
